import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { StreamChat } from 'stream-chat';
import type {
  OwnUserResponse,
  StreamChatOptions,
  TokenOrProvider,
  UserResponse,
} from 'stream-chat';

const useCustomCreateChatClient = ({
  apiKey,
  tokenOrProvider,
  userData,
  enabled,
  options,
}: {
  apiKey: string;
  tokenOrProvider: TokenOrProvider;
  userData: OwnUserResponse | UserResponse;
  enabled: boolean;
  options?: StreamChatOptions;
}) => {
  const [chatClient] = useState(
    () => new StreamChat(apiKey, undefined, options),
  );

  const { data, isError, refetch, isFetching } = useQuery({
    queryKey: ['chatClient', userData.id],
    queryFn: async () => {
      await chatClient.connectUser(userData, tokenOrProvider);
      return chatClient;
    },
    enabled: !!userData.id && enabled,
    staleTime: Infinity,
    cacheTime: Infinity,
  });

  return {
    client: data,
    failedConnection: isError,
    retryConnection: refetch,
    isConnecting: isFetching,
  };
};

export default useCustomCreateChatClient;
